var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('FilterJobLibraries', {
    attrs: {
      "filters": _vm.categoryJobLibrary.params,
      "show-modal-filter": _vm.modalFilter,
      "tab": "category"
    },
    on: {
      "close": function close($event) {
        _vm.modalFilter = false;
      },
      "apply-filter": function applyFilter($event) {
        return _vm.fetchData();
      }
    }
  }), _vm.modalFleet ? [_c('SelectFleetJobLibrary', {
    attrs: {
      "isOpen": _vm.modalFleet,
      "jobLibraryIds": _vm.selectedJobIds
    },
    on: {
      "close": function close($event) {
        _vm.modalFleet = false;
      },
      "next": _vm.onSelectedFleets
    }
  })] : _vm._e(), _c('CustomSidebar', {
    attrs: {
      "size": "100%",
      "title": "New Job Library"
    },
    model: {
      value: _vm.showSidebar,
      callback: function callback($$v) {
        _vm.showSidebar = $$v;
      },
      expression: "showSidebar"
    }
  }, [_vm.showSidebar ? [_c('FormAssignFleets', {
    attrs: {
      "selectedFleets": _vm.selectedFleets
    },
    on: {
      "close": function close($event) {
        _vm.showSidebar = false;
      },
      "refetch": _vm.fetchData
    }
  })] : _vm._e()], 2), [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-flex mb-3"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "id": "fleet_name",
      "type": "text",
      "placeholder": "Search..."
    },
    model: {
      value: _vm.categoryJobLibrary.params.search,
      callback: function callback($$v) {
        _vm.$set(_vm.categoryJobLibrary.params, "search", $$v);
      },
      expression: "categoryJobLibrary.params.search"
    }
  })], 1), _c('b-button', {
    staticClass: "d-flex align-items-center ml-2",
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.modalFilter = true;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sliders"
  }), _c('p', {
    staticClass: "text-truncate m-0"
  }, [_vm._v("Filter Data")])])], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('SettingGeneralReminderModal', {
    staticClass: "mr-2"
  }), _c('ImportAssignJobToFleetModal', {
    attrs: {
      "refetch": _vm.fetchData
    }
  }), _c('b-button', {
    staticClass: "ml-2 d-flex align-items-center",
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "disabled": !_vm.checkedJobs.length,
      "variant": "primary"
    },
    on: {
      "click": _vm.handleOpenModalAssign
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-1"
  }), _vm._v(" Assign Library To Fleet ")])], 1)]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_c('b-form-checkbox', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "checked": _vm.isCheckedAll
    },
    on: {
      "change": _vm.toggleSelectAll
    }
  })], 1), _c('th', [_vm._v("Category Equipment")]), _c('th', [_vm._v("Used For")]), _c('th', [_vm._v("Total Equipment")]), _c('th', [_vm._v("Calendar Trigger")]), _c('th', [_vm._v("Counter Trigger")]), _c('th', {
    staticClass: "text-center",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Action")])])]), _c('tbody', _vm._l(_vm.categoryJobLibrary.data, function (job, index) {
    var _job$total_equipment, _job$calendar_trigger, _job$calendar_trigger2, _job$counter_trigger$, _job$counter_trigger;
    return _c('tr', {
      key: index
    }, [_c('td', [_c('b-form-checkbox', {
      staticClass: "d-flex justify-content-center",
      attrs: {
        "type": "checkbox",
        "value": job.id
      },
      model: {
        value: _vm.checkedJobs,
        callback: function callback($$v) {
          _vm.checkedJobs = $$v;
        },
        expression: "checkedJobs"
      }
    })], 1), _c('td', [_vm._v(_vm._s(job.component_name))]), _c('td', _vm._l(job.used_for, function (type, i) {
      return _c('span', {
        key: i,
        staticClass: "badge badge-light border mr-1 mb-1"
      }, [_vm._v(" " + _vm._s(type === null || type === void 0 ? void 0 : type.name) + " ")]);
    }), 0), _c('td', [_vm._v(_vm._s((_job$total_equipment = job.total_equipment) !== null && _job$total_equipment !== void 0 ? _job$total_equipment : '-') + " Equipment")]), _c('td', [_vm._v(_vm._s((_job$calendar_trigger = (_job$calendar_trigger2 = job.calendar_trigger) === null || _job$calendar_trigger2 === void 0 ? void 0 : _job$calendar_trigger2.count) !== null && _job$calendar_trigger !== void 0 ? _job$calendar_trigger : '0') + " Equipment")]), _c('td', [_vm._v(_vm._s((_job$counter_trigger$ = (_job$counter_trigger = job.counter_trigger) === null || _job$counter_trigger === void 0 ? void 0 : _job$counter_trigger.count) !== null && _job$counter_trigger$ !== void 0 ? _job$counter_trigger$ : '0') + " Equipment")]), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('b-dropdown', {
      attrs: {
        "size": "sm",
        "variant": "outline-primary",
        "text": "Action",
        "right": ""
      }
    }, [_c('b-dropdown-item', {
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.addInterval(job);
        }
      }
    }, [_vm._v(" Detail Library Interval ")]), _c('b-dropdown-item', {
      staticClass: "text-danger",
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.deleteJob(job);
        }
      }
    }, [_vm._v(" Delete ")])], 1)], 1)]);
  }), 0)]), _c('div', {
    staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
  }, [_c('b-pagination', {
    staticClass: "mb-0 mr-3",
    attrs: {
      "total-rows": _vm.categoryJobLibrary.params.total,
      "per-page": _vm.categoryJobLibrary.params.limit,
      "first-number": "",
      "align": "center"
    },
    on: {
      "input": function input() {
        return _vm.fetchData(_vm.categoryJobLibrary.params.page);
      }
    },
    model: {
      value: _vm.categoryJobLibrary.params.page,
      callback: function callback($$v) {
        _vm.$set(_vm.categoryJobLibrary.params, "page", $$v);
      },
      expression: "categoryJobLibrary.params.page"
    }
  }), _c('b-form-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "plain": "",
      "options": _vm.limitOptions
    },
    on: {
      "input": function input() {
        return _vm.fetchData();
      }
    },
    model: {
      value: _vm.categoryJobLibrary.params.limit,
      callback: function callback($$v) {
        _vm.$set(_vm.categoryJobLibrary.params, "limit", $$v);
      },
      expression: "categoryJobLibrary.params.limit"
    }
  })], 1)])]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }